import type { InitSearch } from "@/routes/$locale/$partner/-search-params";

export interface MetadataParams {
	imei?: string;
	brand?: string;
	model?: string;
	capacity?: string;
	memory?: string;
	tranType?: string;
	crrPrgCode?: string;
}

const metadataKeys: (keyof MetadataParams)[] = [
	"imei",
	"brand",
	"model",
	"capacity",
	"memory",
	"tranType",
	"crrPrgCode",
];

type MetadataSource = Partial<InitSearch> | null | undefined;

export function filterMetadataParams(params: MetadataSource): MetadataParams | undefined {
	if (!params) return undefined;

	const metadataParams: MetadataParams = {};
	let hasValue = false;

	for (const key of metadataKeys) {
		const value = params[key];
		if (value !== undefined) {
			metadataParams[key] = value;
			hasValue = true;
		}
	}

	return hasValue ? metadataParams : undefined;
}
